import { render, staticRenderFns } from "./azra_detail.vue?vue&type=template&id=91976384&scoped=true&"
import script from "./azra_detail.vue?vue&type=script&lang=js&"
export * from "./azra_detail.vue?vue&type=script&lang=js&"
import style0 from "./azra_detail.vue?vue&type=style&index=0&id=91976384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91976384",
  null
  
)

export default component.exports